import classnames from "classnames";

import style from "./style.module.scss";
import type { NoticeProps } from "../../types";

function Notice({ className, children, status }: NoticeProps) {
  return (
    <div className={classnames(className, style.notice, status && style[status])}>{children}</div>
  );
}

export default Notice;
